import { PermissionResource } from '@entities/client/permission';

import {
  Home01Icon,
  ClipboardIcon,
  CreditCard01Icon,
  Ticket01Icon,
  Users02Icon,
  User01Icon,
  ClockIcon,
  ReceiptIcon,
  FolderIcon,
  BarLineChartIcon,
} from '@shared/ui/icons';
import type { ClientNavItem } from '../model';

import { sx } from './navigation-icon-sx';

export const clientNavigationItems: ClientNavItem[] = [
  {
    label: 'Головна',
    path: '/',
    icon: <Home01Icon sx={sx} />,
  },
  {
    label: 'Талони',
    path: '/coupons',
    resource: PermissionResource.ClientCoupons,
    icon: <Ticket01Icon sx={sx} />,
  },
  {
    label: 'Контракти',
    path: '/contracts',
    resource: PermissionResource.ClientContracts,
    icon: <ClipboardIcon sx={sx} />,
  },
  {
    label: 'Картки',
    path: '/cards',
    resource: PermissionResource.ClientCards,
    icon: <CreditCard01Icon sx={sx} />,
  },
  {
    label: 'Водії',
    path: '/drivers',
    resource: PermissionResource.ClientDrivers,
    icon: <Users02Icon sx={sx} />,
  },
  {
    label: 'Користувачі',
    resource: PermissionResource.ClientUsers,
    icon: <User01Icon sx={sx} />,
    children: [
      {
        label: 'Користувачі',
        path: '/users/list',
      },
      {
        label: 'Ролі',
        path: '/users/roles',
      },
    ],
  },
  {
    label: 'Історія транзакцій',
    resource: PermissionResource.ClientTransactions,
    icon: <ClockIcon sx={sx} />,
    children: [
      {
        label: 'Транзакційні',
        path: '/transactions/transactional',
      },
      {
        label: 'Фінансові',
        path: '/transactions/financial',
      },
    ],
  },
  {
    label: 'Замовлення',
    path: '/orders',
    resource: PermissionResource.ClientFuelOrderCoupons,
    icon: <ReceiptIcon sx={sx} />,
  },
  {
    label: 'Документи',
    path: '/documents',
    icon: <FolderIcon sx={sx} />,
  },
  {
    label: 'Звіти',
    path: '/reports',
    icon: <BarLineChartIcon sx={sx} />,
  },
];
